export enum LocationKind {
  STEP = "step",
  ORDER_DEPARTURE = "orderDeparture",
  ORDER_ARRIVAL = "orderArrival",
  EXTRA_TRAVEL = "extraTravel",
}
